export default "__VITE_ASSET__CJ_ez8jG__"